export const AUTHORISATION_SENDING = 'AUTHORISATION_SENDING'
export const AUTHORISATION_SUCCESSFUL = 'AUTHORISATION_SUCCESSFUL'
export const AUTHORISATION_FAILED = 'AUTHORISATION_FAILED'


// WEBPACK FOOTER //
// ./src/authorisation/constants.js